import React from 'react';
import { useLocation, matchPath } from 'react-router';
import { Link } from 'react-router-dom';

// Types
import { Illustrations } from 'Wpds/components/illustration';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Hooks
import { useOrganizationSubscription } from 'Shared/utils/hooks/use-organization-subscription';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useApp } from 'Shared/utils/hooks/use-app';

import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import { WpModal } from 'Wpds/components/modal';
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import { WpButton } from 'Wpds/components/button';
import EmptyStateContainer from 'Shared/components/EmptyStateContainer/EmptyStateContainer';

// Styles
import './TrialExpiredModal.scss';

const TrialExpiredModal = () => {
  const { pathname } = useLocation();
  const { isTrialExpired } = useOrganizationSubscription();
  const { tr } = useTranslation();

  const { intercomContactSalesEventName } = useApp();
  const { isOrgAdmin } = useCurrentUser();
  const isSettingsPage = matchPath(pathname, { path: [PageUrls.SETTINGS_PAGE] });
  const isAdminPage = matchPath(pathname, { path: [PageUrls.ADMIN] });

  if (isSettingsPage || isAdminPage) return null;
  if (!isTrialExpired) return null;

  const baseClassName = 'TrialExpiredModal';

  return (
    <WpModal size="full" isOpen>
      <WpPageLayout>
        <WpPageBody>
          <div className={`${baseClassName}__util-nav`}>
            <Link to={PageUrls.SETTINGS_PROFILE_PAGE} className={`${baseClassName}__util-nav__link`}>
              Account Settings
            </Link>
            {isOrgAdmin && (
              <Link to={PageUrls.ADMIN_MEMBERS} className={`${baseClassName}__util-nav__link`}>
                {tr('settings.admin.title')}
              </Link>
            )}
          </div>
          <div className={`${baseClassName}__empty`}>
            <EmptyStateContainer
              title={tr('perform.one_on_one_dashboard.trial_expired.title')}
              subTitle={tr('perform.navigation.billing.trial_expired_message')}
              button={
                <WpButton size="lg" dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>
                  {tr('perform.navigation.billing.contact_sales')}
                </WpButton>
              }
              image={Illustrations.stopwatch}
            />
          </div>
        </WpPageBody>
      </WpPageLayout>
    </WpModal>
  );
};

export default TrialExpiredModal;
